import React, {Component} from 'react';
import {ListView, Tabs, Toast} from 'antd-mobile';
import "./style.less";
import Published from "./Published";
import SoldOut from "./SoldOut";
const bbb = require('../../common/image/bbb.jpg');
const bbb1 = require('../../common/image/bbb1.jpg');
export default class FileMy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs:[
                { title: '已发布',},
                { title: '已下架',},
            ],
            data:[
                // {
                //     id:0,
                //     time:"2020-10-10 14:15",
                //     distance:"14.5km",
                //     content:"本人长期高价收购各种二手电脑，台式机、笔记本，量大从优。本人长期高价收购各种二手电脑，台式机、笔记本，量大从优。本人长期高价收购各种二手电脑，台式…",
                //     imgList:[{img:`${bbb}`,},{img:`${bbb1}`,},{img:`${bbb}`,}],
                // },
                // {
                //     id:1,
                //     time:"2020-10-10 14:15",
                //     distance:"1km",
                //     content:"本人长期高价收购各种二手电脑，台式机、笔记本，量大从优。本人长期高价收购各种二手电脑，台式机、笔记本，量大从优。本人长期高价收购各种二手电脑，台式…",
                //     imgList:[{img:`${bbb}`,},{img:`${bbb1}`,},{img:`${bbb}`,}],
                // }
            ],
        };
    }
    componentDidMount() {

    }
    render(){
        return(
            <div className="myLife">
                <Tabs tabs={this.state.tabs}
                      tabBarUnderlineStyle={{'borderColor':'#FFCC00',}}
                      tabBarActiveTextColor="#000000"
                      swipeable={false}
                      prerenderingSiblingsNumber={false}
                >
                    <Published {...this.props}/>
                    <SoldOut {...this.props}/>

                    {/*<div className="tabsList">
                        {
                            this.state.data.map((res ,i)=>(
                                <div className="mylist" onClick={()=>this.props.history.push(`/fileDetail/${res.id}`,{type:1})}  key={i}>
                                    <div className="top">
                                        <div className="time">{res.time}</div>
                                        <div className="dizhi"><span>{res.distance}</span> 可见 </div>
                                    </div>
                                    <div className="con">{res.content}</div>
                                    <div className="imglist">
                                        {
                                            res.imgList.map((res,i)=>(
                                                <img src={res.img} key={i} className={(i+1)%3 === 0? 'margin' : null}/>
                                            ))
                                        }
                                    </div>
                                </div>
                            ))
                        }

                    </div>*/}
                </Tabs>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/MtLife/FileMy.js